import SubscriptionPlansComponent from "../../modules/plans/plans";

export default function Plans() {
    return <SubscriptionPlansComponent role="open" />;
}